// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"0efd85b8","216":"274c4cad","553":"2a3e3798","965":"8df9bd0b"}[chunkId] + ".chunk.js";
};